import { useConfigContext } from '@/context/configContext';
import { Button, Modal, Typography } from '@analytical-alley/ui';

interface Props {
    show: boolean;
    onClose: () => void;
    channelName?: string;
    previousBudget?: number;
    adjustedBudget?: number;
}

export const ZeroInvestmentAdjustmentModal = ({
    show,
    onClose,
    channelName,
    previousBudget,
    adjustedBudget,
}: Props) => {
    const { formatNumber } = useConfigContext();
    const hasBudgetInfo =
        previousBudget !== undefined && adjustedBudget !== undefined;

    return (
        <Modal dismissible show={show} onClose={onClose} popup size="lg">
            <Modal.Header className="mt-5">
                Budget Adjustment Required
            </Modal.Header>
            <Modal.Body>
                <div className="flex flex-col gap-4">
                    <Typography variant="bodyM">
                        Decreasing the investment to 0 for{' '}
                        {channelName ? <b>{channelName}</b> : 'this channel'} is
                        not possible with the current total budget.
                    </Typography>
                    <Typography variant="bodyM">
                        The total budget has been reduced to the nearest valid
                        value to accommodate this change.
                    </Typography>
                    {hasBudgetInfo && (
                        <div className="bg-white/10 p-4 rounded-lg">
                            <table className="w-full">
                                <tbody>
                                    <tr>
                                        <td className="py-1">
                                            <Typography variant="bodyM">
                                                Previous Budget:
                                            </Typography>
                                        </td>
                                        <td className="py-1 text-right">
                                            <Typography variant="bodyM">
                                                <b>
                                                    {formatNumber(
                                                        previousBudget,
                                                    )}
                                                </b>
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="py-1">
                                            <Typography variant="bodyM">
                                                Adjusted Budget:
                                            </Typography>
                                        </td>
                                        <td className="py-1 text-right">
                                            <Typography variant="bodyM">
                                                <b>
                                                    {formatNumber(
                                                        adjustedBudget,
                                                    )}
                                                </b>
                                            </Typography>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="py-4 gap-2">
                <Button size="sm" color="blue" onClick={onClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
